/*

Class for generating an organization

http://www.hl7.org/fhir/organization.html

{
  "state" : "<code>" // active || pending || archive || delete
  "orgId" : "<String>"
  "type" : [{ code }], // Kind of organization
  "name" : "<string>", // C? Name used for the organization
  "alias" : ["<string>"], // A list of alternate names that the organization is known as, or was known as in the past
  "telecom" : [{ ContactPoint }], // C? A contact detail for the organization
  "address" : [{ Address }], // C? An address for the organization
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { codeSchema } = require('./code.class');
const { contactPointSchema } = require('./contactPoint.class');
const { addressSchema } = require('./address.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  orgId: Joi.string().required(),
  type: Joi.array().items(codeSchema).optional(),
  name: Joi.string().required(),
  alias: Joi.array().items( Joi.string().required() ),
  telecom: Joi.array().items( contactPointSchema ).optional(),
  address: Joi.array().items( addressSchema ).required(),
};

// Define class
class Organization extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.org.buildPk(obj.orgId),
      identifiers.org.buildSk(obj.state, obj.orgId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Organization = Organization;
exports.organizationSchema = schema;